import { format } from 'date-fns';

// This function formats a date to the ISO 8601 format eg. yyyy-MM-dd
export const iso8601Date = (date: Date | string) => {
  return format(date, 'yyyy-MM-dd');
};

export const cx = (...classNames: string[]) =>
  classNames.filter(Boolean).join(' ');
